import React, { useContext } from 'react'
import { Card, CardContent, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../../context/DailyMonitoringDetailsFiltersContext'
import DefaultTableCellSmallSpace from '../../../../../../components/DefaultTableCellSmallSpace'
import DailyCheckoutOrdersTotal from './DailyCheckoutOrdersTotal'
import DailyOrdersTotal from './DailyOrdersTotal'
import DailyOrdersQuantity from './DailyOrdersQuantity'
import DailyOrdersAverage from './DailyOrdersAverage'
import DailyOrdersPercentageHistory from './DailyOrdersPercentageHistory'
import { getDaysInMonth, DaysInMonth } from '../../../../../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2)
    }
  })
)

export default function DailyTotals (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)

  return (
    <Card className={classes.root}>
      <CardContent>
      <Typography variant='h6' gutterBottom style={{ color: '#2D4054' }}>Total diário - Cancelamentos</Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <DefaultTableCellSmallSpace style={{ width: 240, fontSize: 12 }}></DefaultTableCellSmallSpace>
                {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
                  return <DefaultTableCellSmallSpace style={{ fontSize: 12, height: 57, textAlign: 'center' }} key={day.date} className={day.isWeekend ? 'weekend' : ''}>{day.date}</DefaultTableCellSmallSpace>
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              <DailyCheckoutOrdersTotal />
              <DailyOrdersTotal />
              <DailyOrdersQuantity />
              <DailyOrdersAverage />
              <DailyOrdersPercentageHistory />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}
